// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-category-materials[data-v-20ccdc43]{padding:15px}", "",{"version":3,"sources":["webpack://./resources/js/apps/attendee-module/views/exhibit-hall/view/exhibit-content-modal.vue"],"names":[],"mappings":"AACA,wCACE,YAAF","sourcesContent":["\n.no-category-materials {\n  padding: 15px 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
